import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import MaterialLinkButton from './material-link-button';
import SocialLinks from './social-links';
import Markdown from './markdown';
import FollowToggle from './users/follow-toggle';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  hostContent: {
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  hostPhoto: {
    paddingRight: 15,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  hostSummary: {
    flexGrow: 1,
    '& > p:first-child': {
      marginTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  avatar: {
    width: 100,
    height: 100,
  },
  chips: {
    margin: theme.spacing(2, 0),
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const HostUserSummary = ({ user }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <Typography variant="h2" className={classes.header}>
        <div>About {user.displayName}</div>
        <FollowToggle user={user} size="small" />
      </Typography>
      <div className={classes.hostContent}>
        <div className={classes.hostPhoto}>
          <Avatar
            alt={user.displayName}
            src={user.avatar.med.url}
            className={classes.avatar}
          />
        </div>
        <div className={classes.hostSummary}>
          <Markdown>{user.summary}</Markdown>
          <SocialLinks source={user} />
          {user.pastHostedEventsCount > 0 && (
            <div className={classes.chips}>
              <Link
                href="/people/[username]/past"
                as={`/people/${user.username}/past`}
                legacyBehavior
              >
                <Chip
                  size="small"
                  label={`${user.pastHostedEventsCount} past event${user.pastHostedEventsCount !== 1 ? 's' : ''}`}
                  variant="outlined"
                  component="a"
                  href={`/people/${user.username}/past`}
                />
              </Link>
            </div>
          )}
          <MaterialLinkButton
            href="/people/[username]"
            as={`/people/${user.username}`}
            variant="outlined"
          >
            {user.displayName}
          </MaterialLinkButton>
        </div>
      </div>
    </Fragment>
  );
}

HostUserSummary.propTypes = {
  user: PropTypes.object.isRequired,
};

export default HostUserSummary;
